// Vendor
import { useRoute } from "vue-router";

// Utils
import { stripTrailingSlash } from "@citizenm/foundation/shared/utils/string";

export default function useSlug(fallback: MaybeRef<string> = "home") {
  const { params } = useRoute();

  const slug = computed(() =>
    params.slug
      ? typeof params.slug === "string"
        ? params.slug
        : stripTrailingSlash(params.slug.join("/"))
      : unref(fallback),
  );

  return {
    slug,
  };
}
